import axios from 'axios';


const endpoint = process.env.VUE_APP_API_ENDPOINT ?? 'https://dev.bots.cierra.ai'

const api = axios.create({
    baseURL: endpoint + '/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to add the guest_token header
api.interceptors.request.use(config => {
    const token = localStorage.getItem('guest_token');
    if (token) {
        config.headers['Guest-Token'] = token;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

const fetchConversation = (bot, conversation) => {
    return api.get(`/chat/${bot}/conversations/${conversation}`);
};

const fetchBot = (bot) => {
    return api.get(`/bots/${bot}`);
};

const createConversation = (bot, payload) => {
    return api.post(`/chat/${bot}/conversations`, payload);
};

const sendMessage = (bot, conversation, payload) => {
    return api.post(`/chat/${bot}/conversations/${conversation}`, payload);
};

const retryMessage = (bot, conversation, ) => {
    return api.post(`/chat/${bot}/conversations/${conversation}/retry`);
}

export default {
    fetchConversation,
    createConversation,
    sendMessage,
    retryMessage,
    fetchBot,
};
